<template>
  <div class="info-wrapper">
    <div class="item-title">
      <el-tooltip effect="dark" :content="item.imageName" placement="top">
        <el-input @blur="onImageNameInputBlur(item)" v-if="item.showInput" size="mini" v-model="item.imageName"></el-input>

        <span v-else @click="emits('select', item.id)" class="tool-span">
          <span class="name"> {{ item.imageName }}</span>
          <span v-if="item.type === 11" @click.stop="onImageNameEdit($event, item)" class="el-icon-edit-outline"> </span
        ></span>
      </el-tooltip>
    </div>
    <div class="item-info">
      <span class="tool-span">{{ item.designerName || '-' }}</span>
      <span>{{ datetimeToSec(item.createTime) }}</span>
    </div>

    <MaterialMediaStates :info="item"></MaterialMediaStates>
  </div>
</template>

<script setup>
import { set, nextTick } from 'vue'
import { Message } from 'view-design'
import { datetimeToSec } from '@/common/js/filters.js'
import { updateImageName } from '@/api/material.model'
import MaterialMediaStates from './material-media-states.vue'
// eslint-disable-next-line
const props = defineProps({
  item: {
    type: Object,
    default: () => {}
  }
})
// eslint-disable-next-line
const emits = defineEmits(['select'])

const onImageNameInputBlur = (item) => {
  updateImageName({ imageDetailId: item.id, imageName: item.imageName }).then((data) => {
    if (data) {
      set(item, 'showInput', false)
      Message.success('素材名称修改成功')
    }
  })
}

const onImageNameEdit = (e, item) => {
  const parentNode = e.target.parentNode.parentNode
  set(item, 'showInput', true)

  nextTick(() => {
    if (parentNode) {
      const input = parentNode.querySelector('input')
      input?.focus()
    }
  })
}
</script>

<style lang="scss">
.media-rejection-text {
  p {
    line-height: 20px;
  }
}
</style>
<style scoped lang="scss">
.info-wrapper {
  padding: 5px;

  > div {
    line-height: 12px;
  }

  .item-title {
    width: 100%;
    color: #1974ff;
    cursor: pointer;

    .tool-span {
      .name {
        width: 240px;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    ::v-deep .el-input {
      .el-input__inner {
        height: 16px;
        line-height: 16px;
      }
    }
  }

  .item-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 2px;

    .tool-span {
      width: 90px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
